import React, { FC } from "react";
import { RegistrationNewManager } from "../../components/AdminManagerInfo/widgets/RegisterNewManager/RegistrationNewManager";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import classes from "./PageUserCreate.module.css";
import { useAppSelector } from "../../store/reduxHooks";

// страница для создания нового менеджера
export const PageUserCreate: FC = () => {
  const navigate = useNavigate();
  const isEditForm = useAppSelector(
    (state) => state.adminManagerInfoSlice.isEditForm,
  );
  return (
    <div className={`${classes.container} ${isEditForm && classes.isEdit}`}>
      <Button
        onClick={() => navigate(-1)}
        className={classes.buttonBack}
        icon={<ArrowLeftOutlined className={classes.buttonBackIconArrow} />}
      >
        Назад
      </Button>
      <div className={`${classes.mainInfoContainer}`}>
        <h1 className={classes.header}>Добавить менеджера</h1>
        <RegistrationNewManager />
      </div>
    </div>
  );
};
